import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

import Image from 'next/image';

type MicroFrontendType = {
    title: string;
};
type MicroFrontendProps = {
    list: MicroFrontendType[];
};
const MicroFrontend = ({ list }: MicroFrontendProps) => {
    return (
        <div className="rgs-microfrontend">
            <FullWrapper isMargin={false}>
                <div className="rgs-microfrontendWrapper">
                    <div className="rgs-microfrontendTitle">Микрофронтенд архитектура</div>
                    <div className="rgs-microfrontendInner">
                        <div className="rgs-microfrontendLeft">
                            <div className="rgs-microfrontendDescription">
                                Мы&nbsp;сосредоточились на&nbsp;разработке фронтенд-части системы,
                                обеспечивая удобный и&nbsp;интуитивно понятный пользовательский
                                интерфейс для продавцов и&nbsp;агентов &laquo;Росгосстраха&raquo;.
                                Такие процессы, как обработка данных и&nbsp;взаимодействие
                                с&nbsp;базами данных, разрабатывались другими командами. Это
                                потребовало плотной координации, чтобы обеспечить бесшовную
                                интеграцию и&nbsp;согласованность между различными компонентами
                                системы.
                            </div>
                            <div className="rgs-microfrontendDescription">
                                Разбиение на&nbsp;микрофронты было одним из&nbsp;ключевых решений
                                для поднятия эффективности разработки. Такой подход позволил
                                серьезно увеличить продуктивность множества параллельно работающих
                                команд, снизить зависимость их&nbsp;друг от&nbsp;друга, позволив
                                деплоить свои решения полностью независимо.
                            </div>
                        </div>
                        <div className="rgs-microfrontendRight">
                            Микрофронтенды были построены на&nbsp;базе webpack module federation.
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="rgs-microfrontendTechnologies">
                <FullWrapper isMargin={false}>
                    <div className="rgs-microfrontendTechnologiesContent">
                        <div className="rgs-microfrontendTechnologiesLeft">
                            <div className="rgs-microfrontendTechnologiesTitle">
                                Технологии для разработки микрофронтендов
                            </div>
                            <div className="rgs-microfrontendTechnologiesList">
                                {list &&
                                    list.map(({ title }) => (
                                        <div
                                            className="rgs-microfrontendTechnologiesItem"
                                            key={title}
                                        >
                                            <div
                                                className="rgs-microfrontendTechnologiesText"
                                                dangerouslySetInnerHTML={{ __html: title }}
                                            ></div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="rgs-microfrontendTechnologiesRight">
                            <Image
                                src="/images/pic/rgs/m1.png"
                                alt="marker"
                                width={780}
                                height={780}
                                className="rgs-microfrontendTechnologiesImg"
                            />
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <FullWrapper isMargin={false}>
                <div className="rgs-microfrontendWrapper">
                    <div className="rgs-microfrontendInner">
                        <div className="rgs-microfrontendLeft">
                            <div className="rgs-microfrontendDescription">
                                Для взаимодействия фронтенда с&nbsp;серверной частью использовали
                                BFF паттерн. В&nbsp;проекте BFF интегрировал данные
                                из&nbsp;нескольких backend-микросервисов и&nbsp;предоставлял
                                их&nbsp;в&nbsp;формате, удобном для микрофронтов.
                            </div>
                            <div className="rgs-microfrontendDescription">
                                Модульный подход обеспечил гибкость системы, ускорил процессы
                                разработки и&nbsp;внедрения новых функций. Благодаря этому подходу
                                каждая команда могла сосредоточиться на&nbsp;своей части
                                функционала, изолировано деплоить правки и&nbsp;в&nbsp;целом
                                защитить слои от&nbsp;случайных изменений.
                            </div>
                            <div className="rgs-microfrontendDescription">
                                В&nbsp;итоге новая система поддерживает гибкое развитие
                                и&nbsp;расширение функционала. Клиент может быстро внедрять новые
                                услуги, модернизировать действующие процессы и&nbsp;улучшать
                                взаимодействие с&nbsp;клиентами.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="rgs-microfrontendDecoration">
                <FullWrapper isMargin={false}>
                    <Image
                        src="/images/pic/rgs/r1.png"
                        alt="marker"
                        width={1230}
                        height={764}
                        className="rgs-microfrontendTechnologiesImg"
                    />
                </FullWrapper>
            </div>
            <div className="rgs-microfrontendDecoration">
                <FullWrapper isMargin={false}>
                    <Image
                        src="/images/pic/rgs/r2.png"
                        alt="marker"
                        width={1296}
                        height={780}
                        className="rgs-microfrontendTechnologiesImg"
                    />
                </FullWrapper>
            </div>
            <FullWrapper isMargin={false}>
                <div className="rgs-microfrontendWrapper">
                    <div className="rgs-microfrontendInner">
                        <div className="rgs-microfrontendLeft">
                            <div className="rgs-microfrontendDescription">
                                Особенностью реализации нашего решения стала мобильная версия
                                системы, которая не&nbsp;просто адаптирована для небольших экранов,
                                а&nbsp;полностью повторяет функционал личного кабинета сотрудника
                                основной платформы. Это обеспечивает непрерывность работы
                                и&nbsp;доступ ко&nbsp;всему функционалу без привязки к&nbsp;офису.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default MicroFrontend;
